import { legacy_createStore as createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from '@redux-devtools/extension';
import { getFirebase } from 'react-redux-firebase';
import { getFirestore } from 'redux-firestore';
import { withExtraArgument } from 'redux-thunk';
import rootReducer from '../reducers/rootReducer';
import firebase from '../config/firebase';

export const configureStore = preloadedState => {
  const thunkWithExtraArg = withExtraArgument({ getFirebase, getFirestore });
  
  const store = createStore(
    rootReducer, 
    preloadedState,
    composeWithDevTools(
      applyMiddleware(thunkWithExtraArg)
    )
  );

  // Create firebase auth ready promise
  store.firebaseAuthIsReady = new Promise((resolve) => {
    const unsubscribe = firebase.auth().onAuthStateChanged(() => {
      unsubscribe();
      resolve();
    });
  });

  if (typeof module !== 'undefined' && module.hot) {
    module.hot.accept('../reducers/rootReducer', () => {
      const newRootReducer = require('../reducers/rootReducer').default;
      store.replaceReducer(newRootReducer);
    });
  }

  return store;
};
